import { arrayMove } from "@dnd-kit/sortable";
import type { Property } from "@ext/properties/models";

export const reorderProperties = (properties: Property[], activeId: string, overId: string): Property[] => {
	if (activeId === overId) return properties;

	const activeIndex = properties.findIndex(({ id }) => id === activeId);
	const overIndex = properties.findIndex(({ id }) => id === overId);
	if (activeIndex === -1 || overIndex === -1) return properties;

	return arrayMove(properties, activeIndex, overIndex);
};
